import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Headbar = () => {
    const location = useLocation();
    
    let currentStep = 1;
    if (location.pathname === '/personal-information') currentStep = 1;
    else if (location.pathname === '/upload-files') currentStep = 2;
    else if (location.pathname === '/upload-success') currentStep = 3;
    else if (location.pathname === '/success') currentStep = 4;

    const steps = [
        { number: 1, label: 'Thông tin khách hàng', path: '/personal-information' },
        { number: 2, label: 'Tải lên hồ sơ', path: '/upload-files' },
        { number: 3, label: 'Gửi hồ sơ', path: '/upload-success' },
        { number: 4, label: 'Hoàn tất', path: '/success' }, 
    ];

    const getLineProgress = (lineIndex) => {
        if (currentStep > lineIndex + 1) {
            return 100; 
        } else if (currentStep === lineIndex + 1) {
            return 0; 
        } else {
            return 0; 
        }
    };

    return (
        <HeaderContainer>
            <StepsWrapper>
                {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                        <StepItem $isCurrent={currentStep === step.number}>
                            <StepCircle $active={currentStep >= step.number}>
                                {step.number}
                            </StepCircle>
                            <StepLabel $active={currentStep >= step.number}>
                                {step.label}
                            </StepLabel>
                        </StepItem>
                        {index < steps.length - 1 && (
                            <ConnectLineWrapper $isCurrent={currentStep === step.number}>
                                <ConnectLineBackground />
                                <ConnectLineProgress $progress={getLineProgress(index)} />
                            </ConnectLineWrapper>
                        )}
                    </React.Fragment>
                ))}
            </StepsWrapper>
        </HeaderContainer>
    );
};

export default Headbar;

const HeaderContainer = styled.div`
    background: white;
    padding: 30px 0;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 0px;
    margin-top: 100px; 

    @media screen and (max-width: 739px) {
        padding:  0;
        margin-top: 80px;
    }
`;

const StepsWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;

    @media screen and (max-width: 739px) {
        max-width: 100%;
        padding: 0 20px;
        justify-content: center;
    }
`;

const StepItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 2;
    flex-shrink: 0;
    width: 80px;

    @media screen and (max-width: 739px) {
        display: ${props => props.$isCurrent ? 'flex' : 'none'};
        width: auto;
    }
`;

const StepCircle = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
    transition: all 0.4s ease;
    background-color: ${props => props.$active ? '#ec1c2b' : '#f0f0f0'};
    color: ${props => props.$active ? 'white' : '#8c8c8c'};
    border: 3px solid ${props => props.$active ? '#ec1c2b' : '#d9d9d9'};

    @media screen and (max-width: 739px) {
        width: 56px;
        height: 56px;
        font-size: 20px;
        border: 3px solid ${props => props.$active ? '#ec1c2b' : '#d9d9d9'};
    }
`;

const StepLabel = styled.span`
    font-size: 15px;
    font-weight: ${props => props.$active ? '600' : '400'};
    color: ${props => props.$active ? 'rgba(0, 0, 0, 0.85)' : '#8c8c8c'};
    text-align: center;
    white-space: nowrap;
    transition: all 0.3s ease;

    @media screen and (max-width: 739px) {
        font-size: 16px;
        font-weight: 600;
        max-width: 200px;
        white-space: normal;
    }
`;

const ConnectLineWrapper = styled.div`
    position: relative;
    flex: 1;
    height: 48px;
    display: flex;
    align-items: center;
    margin: 0 10px;
    min-width: 80px;

    @media screen and (max-width: 739px) {
        display: none;
    }
`;

const ConnectLineBackground = styled.div`
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: #e0e0e0;
    border-radius: 2px;

    @media screen and (max-width: 739px) {
        height: 2px;
    }
`;

const ConnectLineProgress = styled.div`
    position: absolute;
    height: 3px;
    background: linear-gradient(90deg, #ec1c2b 0%, #ff7875 100%);
    border-radius: 2px;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    width: ${props => props.$progress}%;

    @media screen and (max-width: 739px) {
        height: 2px;
    }
`;